import styled, { device, color, css, themeGet } from '@styled'
import { Row } from '@ui/wrapper'

export const SectionWrapper = styled.section`
  padding-block-end: 20px;
  ${device.medium} {
    padding-block-end: 40px;
  }
  ${device.large} {
    padding-block-end: 60px;
  }
  scroll-margin-top: 100px;
  ${color}
`

export const TitleWrapper = styled.div`
  margin-block-start: 15px;
  margin-inline-start: 15px;
  margin-block-end: 25px;
`

export const StyledRow = styled(Row)`
  margin-left: 0px;
  margin-right: 0px;
  ${device.small} {
    margin-left: 17px;
    margin-right: 17px;
  }
`

export const StyledTitle = styled.h3`
  ${({ $layout }) =>
    $layout === 2 &&
    css`
      margin-block-end: 10px;
      ${device.medium} {
        margin-block-end: 20px;
      }
    `}
  span {
    color: ${themeGet('colors.primary')};
  }
`
